import React, { useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft, Heart, Lightbulb, Target, Zap, MessageCircle, Users, Star, LucideIcon } from 'lucide-react';

const questionsData = {
  pt: [
  {
    id: 1,
    set: "I",
    tag: "motivation",
    question: "O que te atraiu primeiro na ideia de automatizar respostas para uma pousada de praia — e por quê?"
  },
  {
    id: 2,
    set: "I",
    tag: "guests",
    question: "Qual momento da jornada do hóspede (descoberta, reserva, check-in, estadia, check-out) você mais gostaria de transformar com AI?"
  },
  {
    id: 3,
    set: "I",
    tag: "delight",
    question: "Que pequena surpresa (um uau sutil) você adoraria que o sistema entregasse sem ninguém pedir?"
  },
  {
    id: 4,
    set: "I",
    tag: "constraints",
    question: "Quais são as três maiores restrições (tempo, orçamento, equipe) e como você pode abraçá-las como guias de design?"
  },
  {
    id: 5,
    set: "I",
    tag: "clarity",
    question: "Se você pudesse resolver só um problema esta semana, qual seria e como saberá que ficou bom?"
  },
  {
    id: 6,
    set: "I",
    tag: "north_star",
    question: "Qual métrica simples poderia ser sua North Star (ex.: tempo médio de resposta, NPS de mensagens, conversão de reservas)?"
  },
  {
    id: 7,
    set: "I",
    tag: "ops",
    question: "Qual tarefa repetitiva a equipe mais odeia e como o bot poderia reduzi-la em 80%?"
  },
  {
    id: 8,
    set: "I",
    tag: "tone",
    question: "Qual é o tom de voz da pousada (ex.: caloroso, brincalhão, elegante) e quais frases-âncora representam isso?"
  },
  {
    id: 9,
    set: "I",
    tag: "bilingual",
    question: "Como o sistema deve alternar suave e respeitosamente entre PT-BR e EN sem parecer robótico?"
  },
  {
    id: 10,
    set: "I",
    tag: "safety",
    question: "Quais limites claros o bot deve ter (ex.: não confirmar preços sem fonte, não prometer upgrades)?"
  },
  {
    id: 11,
    set: "II",
    tag: "playbooks",
    question: "Liste 5 playbooks de conversa que mais geram valor (cotação, dúvidas de localização, passeios, late check-out, ocasiões especiais)."
  },
  {
    id: 12,
    set: "II",
    tag: "data",
    question: "Que dados mínimos (datas, nº hóspedes, preferência de quarto) são essenciais para respostas úteis — e como coletá-los com fricção zero?"
  },
  {
    id: 13,
    set: "II",
    tag: "context",
    question: "Que contexto local (táxi/transfer, maré, restaurantes, passeios) o bot precisa saber para ser realmente útil em Carneiros?"
  },
  {
    id: 14,
    set: "II",
    tag: "templates",
    question: "Quais 3 modelos de mensagem você pode escrever hoje que já economizariam tempo amanhã?"
  },
  {
    id: 15,
    set: "II",
    tag: "handoff",
    question: "Como deve funcionar a passagem para um humano quando o bot não sabe (sinal, SLA, histórico da conversa)?"
  },
  {
    id: 16,
    set: "II",
    tag: "quality",
    question: "Quais 5 critérios de qualidade definem uma boa resposta do bot (clareza, empatia, tempo, utilidade, links corretos)?"
  },
  {
    id: 17,
    set: "II",
    tag: "feedback",
    question: "Como o hóspede pode dar feedback de 1 toque (👍/👎 + motivo) e como isso alimenta melhorias semanais?"
  },
  {
    id: 18,
    set: "II",
    tag: "edge_cases",
    question: "Quais 10 perguntas difíceis/ambíguas o bot deve praticar desde o início?"
  },
  {
    id: 19,
    set: "II",
    tag: "privacy",
    question: "Quais políticas de privacidade/consentimento você precisa comunicar de forma simples e visível?"
  },
  {
    id: 20,
    set: "II",
    tag: "recovery",
    question: "Quando o bot errar, qual sequência de recuperação elegante (desculpa + correção + mimo) deve ocorrer?"
  },
  {
    id: 21,
    set: "III",
    tag: "kpis",
    question: "Que metas de 30/60/90 dias você quer para tempo de resposta, satisfação e conversão?"
  },
  {
    id: 22,
    set: "III",
    tag: "experiments",
    question: "Quais experimentos A/B de alto impacto você pode rodar primeiro (saudação, CTA, resumo de opções)?"
  },
  {
    id: 23,
    set: "III",
    tag: "automation_ladder",
    question: "Que tarefas sobem a escada de automação nos próximos 3 meses (da sugestão → ação semi-automática → ação automática)?"
  },
  {
    id: 24,
    set: "III",
    tag: "integrations",
    question: "Quais integrações priorizar (WhatsApp/Instagram, PMS/Channel Manager, pagamentos/links de reserva)?"
  },
  {
    id: 25,
    set: "III",
    tag: "guardrails",
    question: "Quais políticas operacionais viram guardrails de prompt (overbooking, cancelamentos, upgrades, pets, crianças)?"
  },
  {
    id: 26,
    set: "III",
    tag: "seasonality",
    question: "Como a sazonalidade (feriados, chuva, alta/baixa) muda o tom e as recomendações do bot?"
  },
  {
    id: 27,
    set: "III",
    tag: "proactive",
    question: "Quais mensagens proativas ajudarão mais (pré-chegada com instruções, dicas de maré, reservas de passeio)?"
  },
  {
    id: 28,
    set: "III",
    tag: "moments",
    question: "Que momentos mágicos você quer orquestrar (aniversário, lua de mel, pedido especial) com toques de automação?"
  },
  {
    id: 29,
    set: "III",
    tag: "owner_joy",
    question: "Que parte do trabalho você quer que o sistema torne mais divertida para você, pessoalmente?"
  },
  {
    id: 30,
    set: "III",
    tag: "fail_gracefully",
    question: "Como o sistema deve se comportar quando serviços externos caem (mensagem empática + plano B)?"
  },
  {
    id: 31,
    set: "III",
    tag: "playground",
    question: "Como será seu playground seguro para testar prompts e fluxos sem afetar hóspedes reais?"
  },
  {
    id: 32,
    set: "III",
    tag: "local_flavor",
    question: "Quais expressões e dicas locais (Nordeste, Recife/Carneiros) darão autenticidade às respostas?"
  },
  {
    id: 33,
    set: "III",
    tag: "team_training",
    question: "Como a equipe aprende/treina o bot (notas rápidas, etiquetas de intenção, exemplos aprovados)?"
  },
  {
    id: 34,
    set: "III",
    tag: "docs",
    question: "Qual é o mínimo viável de documentação viva (README operacional, guia de tom, FAQ, changelog)?"
  },
  {
    id: 35,
    set: "III",
    tag: "roi",
    question: "Como você vai demonstrar ROI em 1 slide para qualquer sócio (tempo poupado, upsell, reviews)?"
  },
  {
    id: 36,
    set: "III",
    tag: "love_the_problem",
    question: "Quando você lê estas perguntas, qual problema específico te deixa mais animado hoje — e qual próximo passo micro valida isso?"
  }
  ],
  en: [
    {
      id: 1,
      set: "I",
      tag: "motivation",
      question: "What first attracted you to the idea of automating responses for a beach pousada — and why?"
    },
    {
      id: 2,
      set: "I",
      tag: "guests",
      question: "Which moment of the guest journey (discovery, booking, check-in, stay, check-out) would you most like to transform with AI?"
    },
    {
      id: 3,
      set: "I",
      tag: "delight",
      question: "What small surprise (a subtle wow) would you love the system to deliver without anyone asking?"
    },
    {
      id: 4,
      set: "I",
      tag: "constraints",
      question: "What are your three biggest constraints (time, budget, team) and how can you embrace them as design guides?"
    },
    {
      id: 5,
      set: "I",
      tag: "clarity",
      question: "If you could solve just one problem this week, what would it be and how will you know it's good?"
    },
    {
      id: 6,
      set: "I",
      tag: "north_star",
      question: "What simple metric could be your North Star (e.g., average response time, message NPS, booking conversion)?"
    },
    {
      id: 7,
      set: "I",
      tag: "ops",
      question: "Which repetitive task does the team hate most and how could the bot reduce it by 80%?"
    },
    {
      id: 8,
      set: "I",
      tag: "tone",
      question: "What's the pousada's tone of voice (e.g., warm, playful, elegant) and which anchor phrases represent that?"
    },
    {
      id: 9,
      set: "I",
      tag: "bilingual",
      question: "How should the system smoothly and respectfully switch between PT-BR and EN without seeming robotic?"
    },
    {
      id: 10,
      set: "I",
      tag: "safety",
      question: "What clear limits should the bot have (e.g., don't confirm prices without source, don't promise upgrades)?"
    },
    {
      id: 11,
      set: "II",
      tag: "playbooks",
      question: "List 5 conversation playbooks that generate the most value (quotes, location questions, tours, late check-out, special occasions)."
    },
    {
      id: 12,
      set: "II",
      tag: "data",
      question: "What minimum data (dates, guest count, room preference) is essential for useful responses — and how to collect it with zero friction?"
    },
    {
      id: 13,
      set: "II",
      tag: "context",
      question: "What local context (taxi/transfer, tides, restaurants, tours) does the bot need to know to be truly useful in Carneiros?"
    },
    {
      id: 14,
      set: "II",
      tag: "templates",
      question: "Which 3 message templates can you write today that would save time tomorrow?"
    },
    {
      id: 15,
      set: "II",
      tag: "handoff",
      question: "How should the handoff to a human work when the bot doesn't know (signal, SLA, conversation history)?"
    },
    {
      id: 16,
      set: "II",
      tag: "quality",
      question: "What 5 quality criteria define a good bot response (clarity, empathy, time, usefulness, correct links)?"
    },
    {
      id: 17,
      set: "II",
      tag: "feedback",
      question: "What quick feedback mechanism (thumbs up/down, tags, forward to team) helps improve responses?"
    },
    {
      id: 18,
      set: "II",
      tag: "edge_cases",
      question: "What 3 edge cases require special handling (complaints, emergencies, VIPs) and what are the rules?"
    },
    {
      id: 19,
      set: "II",
      tag: "privacy",
      question: "How to handle guest data with respect (what to store, for how long, who has access)?"
    },
    {
      id: 20,
      set: "II",
      tag: "recovery",
      question: "When the bot makes a mistake, what's the recovery protocol (detect, apologize, compensate)?"
    },
    {
      id: 21,
      set: "II",
      tag: "kpis",
      question: "Which 5 weekly KPIs show the bot is creating value (response time, resolution rate, satisfaction, bookings, team hours saved)?"
    },
    {
      id: 22,
      set: "II",
      tag: "experiments",
      question: "What experiment can you run this week to test a hypothesis (response style, offer timing, language detection)?"
    },
    {
      id: 23,
      set: "III",
      tag: "automation_ladder",
      question: "Draw the automation ladder from manual to fully autonomous — where are you now and what's the next step?"
    },
    {
      id: 24,
      set: "III",
      tag: "integrations",
      question: "Which systems need integration (PMS, calendar, payment) and what's the MVP connection?"
    },
    {
      id: 25,
      set: "III",
      tag: "guardrails",
      question: "What smart guardrails prevent bad outcomes without being annoying (rate limits, escalation rules, blocked terms)?"
    },
    {
      id: 26,
      set: "III",
      tag: "seasonality",
      question: "How should the bot adapt to Carneiros' seasonality (high season, holidays, events, weather)?"
    },
    {
      id: 27,
      set: "III",
      tag: "proactive",
      question: "What proactive messages add value without spamming (reminders, tips, weather, check-in)?"
    },
    {
      id: 28,
      set: "III",
      tag: "moments",
      question: "Which micro-moments of delight can the bot create (welcome by name, birthday, return guest)?"
    },
    {
      id: 29,
      set: "III",
      tag: "owner_joy",
      question: "What feature would bring you the most joy as an owner (seeing happy reviews, time saved, team relief)?"
    },
    {
      id: 30,
      set: "III",
      tag: "fail_gracefully",
      question: "How will the system fail gracefully when WhatsApp/Instagram are down (fallback, notifications, queue)?"
    },
    {
      id: 31,
      set: "III",
      tag: "playground",
      question: "What safe testing ground allows trying new responses without risk (test account, staging, approval mode)?"
    },
    {
      id: 32,
      set: "III",
      tag: "local_flavor",
      question: "What local expression or Carneiros personality makes the bot memorable (not generic)?"
    },
    {
      id: 33,
      set: "III",
      tag: "team_training",
      question: "How does the team learn/train the bot (quick notes, intent tags, approved examples)?"
    },
    {
      id: 34,
      set: "III",
      tag: "docs",
      question: "What's the minimum viable living documentation (operational README, tone guide, FAQ, changelog)?"
    },
    {
      id: 35,
      set: "III",
      tag: "roi",
      question: "How will you demonstrate ROI in 1 slide to any partner (time saved, upsell, reviews)?"
    },
    {
      id: 36,
      set: "III",
      tag: "love_the_problem",
      question: "When you read these questions, which specific problem excites you most today — and what micro next step validates that?"
    }
  ]
};

const tagIcons: Record<string, LucideIcon> = {
  motivation: Heart,
  guests: Users,
  delight: Star,
  constraints: Target,
  clarity: Lightbulb,
  north_star: Target,
  ops: Zap,
  tone: MessageCircle,
  bilingual: MessageCircle,
  safety: Target,
  playbooks: MessageCircle,
  data: Target,
  context: Lightbulb,
  templates: MessageCircle,
  handoff: Users,
  quality: Star,
  feedback: Star,
  edge_cases: Lightbulb,
  privacy: Target,
  recovery: Heart,
  kpis: Target,
  experiments: Lightbulb,
  automation_ladder: Zap,
  integrations: Zap,
  guardrails: Target,
  seasonality: Star,
  proactive: Heart,
  moments: Star,
  owner_joy: Heart,
  fail_gracefully: Heart,
  playground: Lightbulb,
  local_flavor: Star,
  team_training: Users,
  docs: Lightbulb,
  roi: Target,
  love_the_problem: Heart
};

const setColors: Record<string, string> = {
  'I': 'from-blue-500 to-cyan-500',
  'II': 'from-purple-500 to-pink-500',
  'III': 'from-orange-500 to-red-500'
};

const setTitles = {
  pt: {
    'I': 'Descoberta & Direção',
    'II': 'Execução & Estrutura',
    'III': 'Escala & Evolução'
  },
  en: {
    'I': 'Discovery & Direction',
    'II': 'Execution & Structure',
    'III': 'Scale & Evolution'
  }
};

const uiText = {
  pt: {
    title: 'Explorador de Problemas',
    subtitle: '36 perguntas para transformar sua pousada com AI',
    answer: 'Sua resposta',
    answerPlaceholder: 'Compartilhe seus pensamentos e ideias aqui...',
    addInsight: 'Adicionar insight',
    previous: 'Anterior',
    next: 'Próxima',
    viewSummary: 'Ver resumo',
    summaryTitle: 'Seu Mapa de Transformação',
    summarySubtitle: 'Respostas e insights coletados na sua jornada',
    noAnswer: 'Sem resposta ainda',
    insightsTitle: 'Insights Coletados',
    backToQuestions: 'Voltar às perguntas',
    progress: 'Pergunta',
    of: 'de'
  },
  en: {
    title: 'Problem Explorer',
    subtitle: '36 questions to transform your pousada with AI',
    answer: 'Your answer',
    answerPlaceholder: 'Share your thoughts and ideas here...',
    addInsight: 'Add insight',
    previous: 'Previous',
    next: 'Next',
    viewSummary: 'View summary',
    summaryTitle: 'Your Transformation Map',
    summarySubtitle: 'Answers and insights collected on your journey',
    noAnswer: 'No answer yet',
    insightsTitle: 'Collected Insights',
    backToQuestions: 'Back to questions',
    progress: 'Question',
    of: 'of'
  }
};

interface Insight {
  questionId: number;
  text: string;
  timestamp: string;
}

export default function ProblemExplorer() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [insights, setInsights] = useState<Insight[]>([]);
  const [showSummary, setShowSummary] = useState(false);
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [language, setLanguage] = useState<'pt' | 'en'>('pt');
  
  const questions = questionsData[language];
  const ui = uiText[language];
  const titles = setTitles[language];

  // Get API URL based on environment
  const API_URL = import.meta.env.VITE_API_URL || 'https://biig-api.b-9f2.workers.dev';

  // Initialize or load session
  useEffect(() => {
    const initSession = async () => {
      try {
        // Check for existing session in localStorage
        const storedSessionId = localStorage.getItem('problemExplorerSessionId');
        
        if (storedSessionId) {
          // Load existing session
          const response = await fetch(`${API_URL}/api/problem-explorer/session/${storedSessionId}`);
          if (response.ok) {
            const data = await response.json();
            setSessionId(storedSessionId);
            setCurrentIndex(data.session.current_index || 0);
            setShowSummary(data.session.show_summary || false);
            
            // Restore answers
            const answerMap: Record<number, string> = {};
            data.answers.forEach((a: any) => {
              answerMap[a.question_id] = a.answer;
            });
            setAnswers(answerMap);
            
            // Restore insights
            setInsights(data.insights.map((i: any) => ({
              questionId: i.question_id,
              text: i.insight_text,
              timestamp: new Date(i.created_at).toLocaleTimeString()
            })));
          } else {
            // Session not found, create new one
            await createNewSession();
          }
        } else {
          // No stored session, create new one
          await createNewSession();
        }
      } catch (error) {
        console.error('Error initializing session:', error);
        // Work offline if API is unavailable
      } finally {
        setLoading(false);
      }
    };

    const createNewSession = async () => {
      try {
        const response = await fetch(`${API_URL}/api/problem-explorer/session`);
        if (response.ok) {
          const data = await response.json();
          setSessionId(data.session.session_id);
          localStorage.setItem('problemExplorerSessionId', data.session.session_id);
        }
      } catch (error) {
        console.error('Error creating session:', error);
      }
    };

    initSession();
  }, []);

  const currentQuestion = questions[currentIndex];
  const progress = ((currentIndex + 1) / questions.length) * 100;
  const IconComponent = tagIcons[currentQuestion?.tag] || Lightbulb;

  // Auto-save answers
  useEffect(() => {
    const saveAnswer = async () => {
      if (!sessionId || !currentQuestion || !answers[currentQuestion.id]) return;
      
      setSaving(true);
      try {
        await fetch(`${API_URL}/api/problem-explorer/answer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId,
            questionId: currentQuestion.id,
            questionText: currentQuestion.question,
            questionSet: currentQuestion.set,
            questionTag: currentQuestion.tag,
            answer: answers[currentQuestion.id]
          })
        });
      } catch (error) {
        console.error('Error saving answer:', error);
      } finally {
        setSaving(false);
      }
    };

    const debounceTimer = setTimeout(saveAnswer, 1000);
    return () => clearTimeout(debounceTimer);
  }, [answers, currentQuestion, sessionId]);

  // Save session state
  useEffect(() => {
    if (!sessionId) return;
    
    const saveSessionState = async () => {
      try {
        await fetch(`${API_URL}/api/problem-explorer/session/${sessionId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            currentIndex,
            showSummary
          })
        });
      } catch (error) {
        console.error('Error saving session state:', error);
      }
    };

    saveSessionState();
  }, [currentIndex, showSummary, sessionId]);

  const handleAnswerChange = (value: string) => {
    setAnswers(prev => ({
      ...prev,
      [currentQuestion.id]: value
    }));
  };

  const addInsight = async () => {
    const promptText = language === 'pt' 
      ? "💡 Que insight você teve agora? (opcional)"
      : "💡 What insight did you have just now? (optional)";
    const insight = prompt(promptText);
    if (insight) {
      const newInsight = {
        questionId: currentQuestion.id,
        text: insight,
        timestamp: new Date().toLocaleTimeString()
      };
      setInsights(prev => [...prev, newInsight]);
      
      // Save to database
      if (sessionId) {
        try {
          await fetch(`${API_URL}/api/problem-explorer/insight`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              sessionId,
              questionId: currentQuestion.id,
              insightText: insight
            })
          });
        } catch (error) {
          console.error('Error saving insight:', error);
        }
      }
    }
  };

  const nextQuestion = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setShowSummary(true);
    }
  };

  const prevQuestion = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const jumpToSet = (setName: string) => {
    const firstInSet = questions.findIndex(q => q.set === setName);
    if (firstInSet !== -1) {
      setCurrentIndex(firstInSet);
      setShowSummary(false);
    }
  };

  const getAnsweredInSet = (setName: string) => {
    return questions.filter(q => q.set === setName && answers[q.id]).length;
  };

  const getTotalInSet = (setName: string) => {
    return questions.filter(q => q.set === setName).length;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-gray-600">Carregando sua sessão...</p>
        </div>
      </div>
    );
  }

  if (showSummary) {
    const answeredQuestions = Object.keys(answers).length;
    const priorityAnswers = questions
      .filter(q => answers[q.id] && (q.tag === 'love_the_problem' || q.tag === 'clarity' || q.tag === 'motivation'))
      .map(q => ({ question: q.question, answer: answers[q.id] }));

    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6">
        <div className="max-w-4xl mx-auto">
          {/* Language selector */}
          <div className="flex justify-end mb-4 gap-2">
            <button
              onClick={() => setLanguage('en')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                language === 'en' 
                  ? 'bg-blue-500 text-white shadow-lg' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              🇺🇸 English
            </button>
            <button
              onClick={() => setLanguage('pt')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                language === 'pt' 
                  ? 'bg-green-500 text-white shadow-lg' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              🇧🇷 Português
            </button>
          </div>
          
          <div className="bg-white rounded-3xl shadow-2xl p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center gap-3 mb-4">
                <Heart className="text-red-500" size={32} />
                <h1 className="text-3xl font-bold text-gray-800">{ui.summaryTitle}</h1>
              </div>
              <p className="text-lg text-gray-600">
                {language === 'pt' 
                  ? `Você respondeu ${answeredQuestions} de ${questions.length} perguntas`
                  : `You answered ${answeredQuestions} of ${questions.length} questions`}
              </p>
              {sessionId && (
                <p className="text-sm text-gray-500 mt-2">{language === 'pt' ? 'Sessão salva automaticamente' : 'Session saved automatically'}</p>
              )}
            </div>

            {priorityAnswers.length > 0 && (
              <div className="mb-8 p-6 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl border border-red-200">
                <h3 className="font-bold text-lg mb-4 text-red-800">🎯 {language === 'pt' ? 'Seus Insights Principais' : 'Your Key Insights'}</h3>
                {priorityAnswers.map((item, idx) => (
                  <div key={idx} className="mb-4 last:mb-0">
                    <p className="text-sm text-red-600 mb-1">{item.question}</p>
                    <p className="text-red-800 font-medium">{item.answer}</p>
                  </div>
                ))}
              </div>
            )}

            {insights.length > 0 && (
              <div className="mb-8 p-6 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-2xl border border-yellow-200">
                <h3 className="font-bold text-lg mb-4 text-yellow-800">💡 {ui.insightsTitle}</h3>
                {insights.map((insight, idx) => (
                  <div key={idx} className="mb-3 last:mb-0 p-3 bg-white bg-opacity-60 rounded-lg">
                    <p className="text-yellow-800">{insight.text}</p>
                    <p className="text-xs text-yellow-600 mt-1">{insight.timestamp}</p>
                  </div>
                ))}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {['I', 'II', 'III'].map(set => (
                <div key={set} className="text-center">
                  <div className={`bg-gradient-to-r ${setColors[set]} text-white p-6 rounded-2xl shadow-lg cursor-pointer hover:shadow-xl transition-all`}
                       onClick={() => jumpToSet(set)}>
                    <h3 className="font-bold text-lg mb-2">{titles[set as 'I' | 'II' | 'III']}</h3>
                    <div className="text-3xl font-bold">{getAnsweredInSet(set)}/{getTotalInSet(set)}</div>
                    <p className="text-sm opacity-90">{language === 'pt' ? 'perguntas respondidas' : 'questions answered'}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button 
                onClick={() => setShowSummary(false)}
                className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-2xl font-medium hover:shadow-lg transition-all"
              >
                {ui.backToQuestions}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Language selector */}
        <div className="flex justify-end mb-4 gap-2">
          <button
            onClick={() => setLanguage('en')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${
              language === 'en' 
                ? 'bg-blue-500 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-gray-100'
            }`}
          >
            🇺🇸 English
          </button>
          <button
            onClick={() => setLanguage('pt')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${
              language === 'pt' 
                ? 'bg-green-500 text-white shadow-lg' 
                : 'bg-white text-gray-600 hover:bg-gray-100'
            }`}
          >
            🇧🇷 Português
          </button>
        </div>
        
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <Heart className="text-red-500" size={32} />
            <h1 className="text-3xl font-bold text-gray-800">{ui.title}</h1>
          </div>
          <p className="text-lg text-gray-600">{ui.subtitle}</p>
        </div>

        <div className="mb-8">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-600">{ui.progress}</span>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-600">{currentIndex + 1} {ui.of} {questions.length}</span>
              {saving && (
                <span className="text-xs text-blue-500">{language === 'pt' ? 'Salvando...' : 'Saving...'}</span>
              )}
            </div>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div 
              className={`bg-gradient-to-r ${setColors[currentQuestion.set]} h-3 rounded-full transition-all duration-500`}
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mb-8">
          {['I', 'II', 'III'].map(set => (
            <button
              key={set}
              onClick={() => jumpToSet(set)}
              className={`p-4 rounded-2xl transition-all ${
                currentQuestion.set === set 
                  ? `bg-gradient-to-r ${setColors[set]} text-white shadow-lg` 
                  : 'bg-white text-gray-600 hover:shadow-md'
              }`}
            >
              <div className="font-bold">{titles[set as 'I' | 'II' | 'III']}</div>
              <div className="text-sm opacity-80">{getAnsweredInSet(set)}/{getTotalInSet(set)} {language === 'pt' ? 'respondidas' : 'answered'}</div>
            </button>
          ))}
        </div>

        <div className="bg-white rounded-3xl shadow-2xl p-8 mb-8">
          <div className="flex items-start gap-4 mb-6">
            <div className={`p-4 rounded-2xl bg-gradient-to-r ${setColors[currentQuestion.set]} text-white`}>
              <IconComponent size={24} />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <span className={`px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${setColors[currentQuestion.set]} text-white`}>
                  {currentQuestion.tag}
                </span>
                <span className="text-sm text-gray-500">Pergunta {currentQuestion.id}</span>
              </div>
              <h2 className="text-xl font-bold text-gray-800 leading-relaxed">
                {currentQuestion.question}
              </h2>
            </div>
          </div>

          <textarea
            value={answers[currentQuestion.id] || ''}
            onChange={(e) => handleAnswerChange(e.target.value)}
            placeholder="Sua resposta aqui... Seja específico e honest. O que realmente te incomoda neste aspecto?"
            className="w-full h-32 p-4 border-2 border-gray-200 rounded-2xl focus:border-blue-400 focus:outline-none resize-none text-gray-700"
          />

          <div className="flex justify-between items-center mt-6">
            <button
              onClick={addInsight}
              className="flex items-center gap-2 px-4 py-2 text-amber-600 hover:bg-amber-50 rounded-xl transition-all"
            >
              <Lightbulb size={20} />
              {ui.addInsight}
            </button>

            <div className="flex gap-3">
              <button
                onClick={prevQuestion}
                disabled={currentIndex === 0}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl transition-all"
              >
                <ChevronLeft size={20} />
                {ui.previous}
              </button>
              
              <button
                onClick={nextQuestion}
                className={`flex items-center gap-2 px-6 py-2 text-white rounded-xl transition-all bg-gradient-to-r ${setColors[currentQuestion.set]} hover:shadow-lg`}
              >
                {currentIndex === questions.length - 1 ? (language === 'pt' ? 'Finalizar' : 'Finish') : ui.next}
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>

        {insights.length > 0 && (
          <div className="bg-gradient-to-r from-yellow-50 to-amber-50 rounded-2xl p-6 border border-yellow-200">
            <h3 className="font-bold text-yellow-800 mb-4">💡 {ui.insightsTitle} ({insights.length})</h3>
            <div className="space-y-2">
              {insights.slice(-3).map((insight, idx) => (
                <div key={idx} className="text-sm text-yellow-700 bg-white bg-opacity-60 p-3 rounded-lg">
                  {insight.text}
                </div>
              ))}
            </div>
            {insights.length > 3 && (
              <button 
                onClick={() => setShowSummary(true)}
                className="text-yellow-600 hover:text-yellow-800 text-sm mt-2"
              >
                {language === 'pt' ? 'Ver todos os insights →' : 'View all insights →'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}